<template>
  <div class="wrestler-invite-row flex-col-xs-only border-y p-y-sm border-gray-50 border-solid flex gap-sm justify-space-between">
    <div>
      <div class="flex items-center gap-x-xs">
        <h3 class="font-semi m-b-none m-t-none">{{ wrestler.full_name }}</h3>
        <span v-if="active" class="badge badge-success">Active</span>
        <span v-if="invited" class="badge badge-warning">Invited</span>
      </div>
      <div v-if="active" :class="forAppEmbed ? '' : 'text-gray-600'">
        {{ wrestler.email }}
      </div>
      <div v-if="invited" :class="forAppEmbed ? '' : 'text-gray-600'">
        {{ wrestler.invite_email }}
      </div>
    </div>
    <invite :for-app-embed="forAppEmbed" :wrestler-id="wrestler.id" :reload-page="true" v-if="inactive" :wrestler-first-name="wrestler.first_name" :wrestler-dob="wrestler.dob || ''" :is-guardian="isGuardian"></invite>
  </div>
</template>

<script>
import Invite from './invite.vue';
import { appEmbedMix } from "./mixins/app_embed_mix";

export default {
  name: 'WrestlerInviteRow',
  mixins: [appEmbedMix],
  components: { Invite },
  props: {
    wrestler: {
      type: Object,
      required: true,
    },
    isGuardian: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    active() {
      return this.wrestler.user_status === 'active';
    },
    invited() {
      return this.wrestler.user_status === 'invited';
    },
    inactive() {
      return !this.active && !this.invited;
    }
  }
};
</script>
